<template>
    <div>
      <div id="app" class="mt-1" >
        <!--<install-prompt></install-prompt>-->
        <!--測試背景把推播跳出來的機制
        <b-button @click="msgtest">測試訊息</b-button>-->
        <!--<b-button @click="permit">接收訊息</b-button>-->
        <b-container id='landing' :class="checkMobile()?'nav-wrapper':''" fluid>
        <b-navbar class="m-nav" toggleable="md" >
          <b-navbar-toggle ref="toggler" target="nav_collapse"></b-navbar-toggle>
          <b-navbar-brand href="#">耐德Professional SPA</b-navbar-brand>
          <b-collapse is-nav id="nav_collapse" v-model="expandMenu">
            <b-navbar-nav ref="sideBar">
              <template 
                v-for="item in roleFunctionItems"
              >
                <b-nav-item
                  v-if="item.actionComponent!==''"
                  :ref="'item'+item.index" 
                  :class="sideBarSelectIndex == item.index?'selected-action':''"
                  :key="item.index" 
                  @click="UpdateFocus(item.index)">
                  <img v-if="item.imgUrl" class="nav-item-icon-img" :src="item.imgUrl"/>
                  <font-awesome-icon v-if="item.faicon" class="m-auto" style="" fixed-width :icon="['fas',item.faicon]" />
                  <br v-if="!checkMobile()" />
                  {{item.FunTitle}}
                </b-nav-item>
                <b-nav-item-dropdown 
                  v-if="item.actionComponent===''&& item.subActions.length" 
                  :key="item.index"
                  :active="sideBarSelectIndex == item.index"
                  :class="sideBarSelectIndex == item.index?'selected-action':''"
                >
                  <template slot="button-content">
                    <!--可以用font-awesome-icon代替,網路上找到的右邊參數前面的fa拿掉才找得到-->
                    <!--<font-awesome-icon fixed-width :icon="['far','folder-open']" />-->
                    <img v-if="item.imgUrl" class="nav-item-icon-img" :src="item.imgUrl"/>
                    <font-awesome-icon v-if="item.faicon" class="m-auto" style="" fixed-width :icon="['fas',item.faicon]" />
                    <br v-if="!checkMobile()" />
                    {{item.FunTitle}}
                  </template>
                  <b-dropdown-item
                    v-for="subitem in item.subActions"   
                    :key="subitem.index"
                    @click="UpdateFocus(item.index,subitem.index)"
                  >
                    {{subitem.FunTitle}}
                  </b-dropdown-item>
                </b-nav-item-dropdown>
              </template>
            </b-navbar-nav>
          </b-collapse>
          <b-navbar-nav :class="!checkMobile()?'ml-auto':'mx-auto'">
            <b-nav-item-dropdown v-if="$bus.session" :right="!checkMobile()" >
              <template slot="button-content">
                <em>{{$bus.session.name}}</em>
              </template>
              <b-dropdown-item @click="showEditProfile">設定</b-dropdown-item>
              <b-dropdown-item v-show="false&&isLineWebkit()===false" @click="permit">{{NotificationPermitted?'關閉':'接受'}}通知</b-dropdown-item>
              <b-dropdown-item v-if="['merchant','spalogin'].includes($bus.getRole())&&$bus.line_uid" @click="unbindAccount" >解綁Line登出</b-dropdown-item>
              <b-dropdown-item v-if="isLineWebkit()===false||!$bus.line_uid" @click="logoutAccount" >登出</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item v-if="!$bus.session&&$bus.getRole()!=='merchant_empty'" @click="goLogin2" right>
              登入
            </b-nav-item>
          </b-navbar-nav>
        </b-navbar>
        <landing-page
          ref="wrapper2"
          :loginRedirect="setLoginData"
          :loginTarget="loginTarget"
        />
      </b-container>
    </div>
    <b-modal
      ref="topPopup"
      v-model="acBox.show"
      centered
      hide-header
      hide-footer
      :size="acBox.boxSize"
      @hide="closeModalCheck"
      @shown="openModalFocus"
    >
      <div :class="acBox.bType">
        <div style="float:left;width:40px;height:40px;background-color:white;border-radius:50%;padding:5px;border-style:solid;border-color:darkgrey;">
          <font-awesome-icon class="m-auto" style="width:100%;height:100%;" v-if="acBox.bType==='bInfo'" fixed-width :icon="['fas','info']" />
          <font-awesome-icon class="m-auto" style="width:100%;height:100%;" v-if="acBox.bType==='bConfirm'" fixed-width :icon="['fas','question']" />
        </div>
        <span class="center-block" v-html="acBox.content" />
      </div>
      <div :class="acBox.bType">
        <b-container>
          <b-row>
            <b-col v-show="acBox.btnCancel">
              <b-btn size="sm" ref="btnClose" class="center-block" variant="secondary" @click="acBox.confirmCancel">
                關閉
              </b-btn>
            </b-col>
            <b-col v-show="acBox.btnOK">
              <b-btn size="sm" ref="btnOK" class="center-block" variant="secondary" @click="acBox.confirmOK">
                確認
              </b-btn>              
            </b-col>
          </b-row>
        </b-container>

      </div>
    </b-modal>
    <div class='bottom-navigator' v-if="checkMobile()&&$bus.getRole()!='admin'&&!$bus.hideMobileNavi">
       <b-navbar class="btm-nav" justified >
        <b-nav-item @click="UpdateFocus(0)"><font-awesome-icon class="m-auto fa-2x" fixed-width :icon="['fas','home']" /></b-nav-item>   
        <!-- <b-nav-item v-if="$bus.session&&!$bus.session.is_super_manage" @click="UpdateFocus(2)">核銷<font-awesome-icon class="m-auto fa-lg" fixed-width :icon="['fas','hand-holding-usd']" /></b-nav-item>    -->
        <b-nav-item v-if="$bus.session&&!$bus.session.is_super_manage" @click="UpdateFocus(3)">核銷<font-awesome-icon class="m-auto fa-lg" fixed-width :icon="['fas','hand-holding-usd']" /></b-nav-item>
        <b-nav-item v-else-if="$bus.session&&$bus.session.is_super_manage" @click="UpdateFocus(4)">核銷<font-awesome-icon class="m-auto fa-lg" fixed-width :icon="['fas','hand-holding-usd']" /></b-nav-item> 
        <b-nav-item @click="toggleMenu">更多<font-awesome-icon class="m-auto fa-lg" fixed-width :icon="['fas','arrow-alt-circle-up']" /></b-nav-item>   
       </b-navbar>
    </div>
  </div>
</template>

<script>

import LandingPage from "./Landing/LandingPage.vue"
// import InstallPrompt from "./Landing/InstallPrompt.vue"
import {
  apiBindLineLogin,
  apiLogout
} from '@/api/Merchant.js'

export default {
  name: 'IndexPage',
  data: function () {
    return {
      bchannel: null,
      //message channel
      msgc:null,
      //message channel port from SW=> not effective= =
      //msgcc:null,
      notinstalled:false,
      loginResult: Object,
      sideBarSelectIndex: 0,
      //mobile hamburgur collapse default not collapsed
      expandMenu:false,
      // generig popup attributes
      acBox: {
        bType: "bInfo",
        show: false,
        title: "",
        content: "",
        btnOK: true,
        btnCancel: false,
        needFreeze: true,
        boxSize: 'md',
        // temporary ok cancel callback injection
        confirmOK: function () {this.acBox.show = false},
        confirmCancel: function () {this.acBox.show = false}
      },
    }
  },
  components: {
    LandingPage,
    // InstallPrompt,
  },
  props: {

  },
  methods: {
    permit() {
      if (Notification.permission!=='granted') {
        //不允許時請求允許(邏輯上只會顯示請求允許),成功後呼叫api更新推播接受改開啟
        Notification.requestPermission(function(result) {
          console.log("User choice", result);
          if (result !== "granted") {
            console.log("No notification permission granted!");
            let Param = {
              module:'merchant',
              method:'switchPushSetting',
              allow_push:1
            }
            this.$bus.apiCall(Param, function(data, vm) {
              if (data.ok == 0) {
                
                vm.$bus.fnShowInfo('接受通知失敗：'+data.msg)
                return
              }
              vm.$bus.fnShowInfo('接受通知成功')
              vm.$bus.session.allow_push = 1
            }, this)

          } else {
            console.log('granted')        
          }
        });
      }
      else {
        //本來網站通知權限就已開啟了,只做店家帳號是否接受通知設定的開關切換
        let Param = {
          module:'merchant',
          method:'switchPushSetting',
          allow_push:1
        }
        //已開啟則是關閉
        if (this.$bus.session.allow_push) {
          Param.allow_push = 0
        }
        this.$bus.apiCall(Param, function(data, vm) {
          if (data.ok == 0) {
            vm.$bus.fnShowInfo('接受通知變更失敗：'+data.msg)
            return
          }
          vm.$bus.session.allow_push = Param.allow_push
          vm.$bus.fnShowInfo( (Param.allow_push?'接受':'關閉') + '通知成功')
        }, this)
      }
    },
    msgtest() {
      // options可以指定圖片與內文等等, actions則只能在service-worker內呼叫showNotification時才可以使用
      const options = {
        body: 'This notification was generated from a push!',
        icon: '',
        data: {
            dateOfArrival: Date.now(),
            primaryKey: '2'
        }/*,
        actions: [
            {
                action: 'explore', title: 'Explore this new world',
                icon: ''
            },
            {
                action: 'close', title: 'Close',
                icon: ''
            },
        ]*/
      };
      //這樣就可以彈出顯示文字訊息了(沒有options也可以就通知一句話)
      //如果把Notification的結果用變數接起來,可以對其onclick,onclose的事件做處理(還沒try與測試)
      //new Notification("message test spaspa", options);
      
      /*msg.port2.onmessage = function(event){
          //Response received from SW
          console.log('portB',event.data);
      };*/
      // Send message to SW
      // SW在註冊完的activate事件裡要self.clients.claim()才能在navigator.serviceWorker下找到controller
      // 送port2過去,這邊要listen port1
      //navigator.serviceWorker.controller.postMessage("hello establish channel", [this.msgc.port2]);
      // 經測試 SW與Page各建立一個同名的BroadcastChannel,即可以讓兩邊用postMessage與onmessage來做訊息的交互溝通
      // navigator.serviceWorker.controller取得postMessage的方式依賴用一次的MessageChannel且是單向所以就別用了
      // (在這裡怎麼接受SW的postMessage? SW postMessage會post給誰？太多不可控,所以簡單用BroadcastChannel)
      /*if (this.bchannel.postMessage) {
        this.bchannel.postMessage('廣播送message給SW')
      }*/
      // 下面是嘗試建一個port和SW直接通信的失敗嘗試
      //if (this.msgcc) {
        //console.log('wtf?',this.msgcc)
        //this.msgcc.postMessage('msgcc send msg to sw')
      //}
      // 要把訊息post給SW還是得這樣呼叫,這個按鈕click是測試推播彈出就用保留字讓SW判斷要彈訊息
      navigator.serviceWorker.controller.postMessage("pushmsgtest")
    },
    toggleMenu() {
      window.scrollTo(0,0)
      this.$refs.toggler.$el.click()
    },
    showEditProfile () {
      this.$refs.wrapper2.showEditProfile()
    },
    setLoginData: function (data, landing = '') {
      this.loginResult = data
      this.$bus.session = data
      // login type from url
      const session_key = this.$bus.getRole() + '_session'
      window.localStorage.setItem(session_key, JSON.stringify(data))
      // 登入前停在功能選單的第幾個,登入成功後要用登入後狀態自動重新載入該頁
      // settimeout是必要的,要等組件載入完成
      if (!this.checkMobile()) {
        //不要等300毫秒太久會閃
        this.$nextTick(()=>{
          if (this.$refs.sideBar.children.length < (this.sideBarSelectIndex-1)) {
            //重登切換角色時選單跑掉,避免冒出foucs錯誤
            this.sideBarSelectIndex = 0
          }
          //不要用click component直接set landingComponent切換,click事件太亂會切換異常
          //登入頁如果是連結過來指定要開的功能因未登入而先去登入 則需要繼續導過去原來指定的component
          let urllanding = this.getQueryVariable('landing')
          if (!urllanding && landing) {
            urllanding = landing
          }
          if (urllanding && this.checkCanJump(urllanding) ) {
              this.$bus.landingComponent = urllanding
              //let optional_hash = location.hash.substr(0,location.hash.indexOf('?'))
              //this.resetUrlQuery(optional_hash)
          }
          else {
            //登入後只要沒有上次的index就是第一個功能為首頁就對了
            this.$bus.landingComponent = this.roleFunctionItems[this.sideBarSelectIndex].actionComponent
          }
        })
      }
      else {
        //手機時跑這一段
        //登入頁如果是連結過來指定要開的功能因未登入而先去登入 則需要繼續導過去原來指定的component
        let urllanding = this.getQueryVariable('landing')
        if (!urllanding && landing) {
          urllanding = landing
        }
        if (urllanding && this.checkCanJump(urllanding) ) {
            this.$bus.landingComponent = urllanding
            //let optional_hash = location.hash.substr(0,location.hash.indexOf('?'))
            //this.resetUrlQuery(optional_hash)
        }
        else {
          //登入後只要沒有上次的index就是第一個功能為首頁就對了
          this.$bus.landingComponent = this.roleFunctionItems[this.sideBarSelectIndex].actionComponent
        }
      }
      //login完成一律把hash以外的參數從uri幹掉
      let optional_hash = location.hash.indexOf('?')!==-1?location.hash.substr(0,location.hash.indexOf('?')):location.hash
      this.resetUrlQuery(optional_hash)
      //登入後,如果是collapse點登出狀態登入的,登入成功後預設關起來
      if (this.expandMenu) {
        this.expandMenu = false
      }
    },
    unbindAccount() {
      if (!this.$bus.session) {
        alert('未登入狀態無需解除綁定')
        return
      }
      if (!this.$bus.session.line_store_user_id) {
        alert('非綁定登入狀態無須操作解除綁定')
        return
      }

      let Param = {
        module:'merchant',
        method:'merchant_logout',
        unbind_line_id:this.$bus.session.line_store_user_id
      }
      
      let vm = this
      apiLogout(Param).then(function(resp){
        let data = resp.data
        vm.$bus.fnShowInfo("解除綁定並登出成功,下次由Line打開時將重新綁定")
        setTimeout(() => {
          vm.$bus.session = null
          const session_key = vm.$bus.getRole() + '_session'
          window.localStorage.removeItem(session_key)
        }, 2000);

      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
           vm.$bus.fnShowInfo(data.msg)
           setTimeout(function(){
            window.location.reload()
           }, 1000)
           return
        }
      })

      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //      vm.$bus.fnShowInfo(data.msg)
      //      return
      //   }
      //   vm.$bus.fnShowInfo("解除綁定並登出成功,下次由Line打開時將重新綁定")
      //   setTimeout(() => {
      //     vm.$bus.session = null
      //     const session_key = vm.$bus.getRole() + '_session'
      //     window.localStorage.removeItem(session_key)
      //   }, 2000);
      // }, this)
    },
    logoutAccount: function () {
      // 是商家帳號才需要呼叫api登出,其他的清session回登入頁即可
      if (!this.$bus.session) {
        alert('未登入不需登出')
        return
      }

      let Param = {} // {'module':'merchant','method':'merchant_logout'}
      let role = this.$bus.getRole()
      let module = 'merchant'
      let method = 'merchant_logout'
      // let api_role = 'merchant_admin'
      if (role === 'admin' ) {
        // api_role = 'business_admin'
        module = 'admin_manage'
        method = 'admin_logout'
        // alert('後台不需登出')
        this.$bus.session = null
        const session_key = this.$bus.getRole() + '_session'
        window.localStorage.removeItem(session_key)
        return
      }
      else if (role === 'user') {
        // api_role = 'app_user'
        module = 'user'
        method = 'user_logout'
        this.$bus.session = null
        const session_key = this.$bus.getRole() + '_session'
        window.localStorage.removeItem(session_key)
      }
      Param = {
        'module':module,
        'method':method
      }
      let vm = this
      apiLogout(Param).then(function(resp){
        let data = resp.data
        vm.$bus.fnShowInfo("登出成功")
        setTimeout(() => {
          vm.$bus.session = null
          const session_key = vm.$bus.getRole() + '_session'
          window.localStorage.removeItem(session_key)
        }, 2000);
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
           vm.$bus.fnShowInfo(data.msg)
           setTimeout(function(){
            window.location.reload()
           }, 1000)
           return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //      vm.$bus.fnShowInfo(data.msg)
      //      return
      //   }
      //   vm.$bus.fnShowInfo("登出成功")
      //   setTimeout(() => {
      //     vm.$bus.session = null
      //     const session_key = vm.$bus.getRole() + '_session'
      //     window.localStorage.removeItem(session_key)
      //   }, 2000);
      // }, this)
    },
     UpdateFocus: function (index, subindex) {
      console.log(index)
      console.log(subindex)
      let pathname = ''

       if (this.expandMenu) {
         this.expandMenu = false
       }
       if (!subindex) {
          console.log("1");
          console.log(this.roleFunctionItems);
          this.$bus.landingComponent = this.roleFunctionItems[index].actionComponent
          pathname = this.roleFunctionItems[index].pathname
       }
       else {
          console.log("2");
          this.$bus.landingComponent = this.roleFunctionItems[index].subActions[subindex-1].actionComponent
       }

      console.log(pathname)
      window.history.pushState('', document.title, pathname)
      this.sideBarSelectIndex = index
    },
    goLogin2() {
      this.$bus.session = undefined
      setTimeout(() => {
        this.goLogin(this)
      }, 100);
    },
    goLogin(vm) {
      vm.$bus.session = null
    },
    // modal dialoge用的
    closeModalCheck: function (evt) {
      // 別漏了this.acBox.show的判斷,不然有時差會徹底關不掉
      if (this.acBox.needFreeze && this.acBox.show) {
        evt.preventDefault()
      }
    },
    openModalFocus() {
      // 此foucs只是讓桌機操作時也可以用鍵盤enter確認
      // 此if僅防呆,確保至少有一個按鈕可以foucs時才做focus
      if (this.acBox.btnCancel || this.acBox.btnOK) {
        setTimeout(() => {
          if (this.acBox.btnCancel) {
            this.$refs.btnClose.focus()
          }
          else if (this.acBox.btnOK) {
            this.$refs.btnOK.focus()
          }          
        }, 500);        
      }
    },
    // 沒注入掛載callback的預設關閉confirm-alert方法
    // 若有ok / cancel的指定callback 
    acBoxClose() {
      this.acBox.show = false
    },
    showInfo(msg, freeze = false, OKCB = null, title = "") {
      // 不允許重複打開
      if (this.acBox.show) {
        return false
      }
      // just inform, no need to provide callback
      this.acBox.bType = "bInfo"
      this.acBox.show = true
      this.acBox.title = title
      this.acBox.content = msg
      this.acBox.btnOK = true
      this.acBox.btnCancel = false
      this.acBox.needFreeze = freeze
      this.acBox.boxSize = 'md'
      // 這個不能漏,否則可能會有殘留之前的callback被呼叫
      this.acBox.confirmOK = OKCB!==null?OKCB:this.acBoxClose
      this.acBox.confirmCancel = this.acBoxClose
    },
    showConfirm(msg, OKCB = null, cancelCB = null, freeze = true) {
      if (this.acBox.show) {
        return false
      }
      // just inform, no need to provide callback
      this.acBox.bType = "bConfirm"
      this.acBox.show = true
      this.acBox.title = ""
      this.acBox.content = msg
      this.acBox.btnOK = true
      this.acBox.btnCancel = true
      this.acBox.needFreeze = freeze
      this.acBox.boxSize = 'md'
      this.acBox.confirmOK = OKCB!==null?OKCB:this.acBoxClose
      this.acBox.confirmCancel = cancelCB?cancelCB:this.acBoxClose
    },
    checkCanJump(target) {
      //要用landing跳功能組件時,要在自身權限陣列有找到此組件配置
      for (let i=0;i<this.roleFunctionItems.length;i++){
        if (this.roleFunctionItems[i].actionComponent === target) {
          return true
        }
        else if (this.roleFunctionItems[i].subActions) {
          for (let j=0;j<this.roleFunctionItems[i].subActions.length;j++){
            if (this.roleFunctionItems[i].subActions[j].actionComponent === target) {
              return true
            }
          }
        }
      }
      return false
    }
  },
  computed: {
    NotificationPermitted () {
      return true // Notification&&Notification.permission==='granted'&&this.$bus.session&&this.$bus.session.allow_push
    },
    loginTarget () {
      return this.$bus.getRole()==='spalogin'?'merchant':this.$bus.getRole()
    },
    roleFunctionItems: function () {
      // local asset img url不能直接使用相對路徑,要require取得實際的圖片再assign,再不然就要用絕對網址的cdn url,動態載入時才能顯示
      // 還沒ok,商家重要訊息因應是否總管理者有多型需替換component,多型者需要一個頭的組件wrapper包起來
      if (this.$bus.getRole() === 'admin') {
        if (!this.$bus.session || !this.$bus.session.role_type) {
          return this.$bus.roleFunctionsMap['admin']
        }
        switch (this.$bus.session.role_type) {
          case 'sys_admin':
            return this.$bus.roleFunctionsMap['admin']
          case 'sales_mgr':
          case 'sales':
            return this.$bus.roleFunctionsMap['admin_sales']
          case 'support_mgr':
          case 'support':
            return this.$bus.roleFunctionsMap['admin_support']
        }
        return this.$bus.roleFunctionsMap['admin']
      }
      else if (this.$bus.getRole() ==='user') {
        return this.$bus.roleFunctionsMap['user']
      }
      else if (this.$bus.getRole() ==='merchant_empty') {
        return []
      }
      else if (['merchant','spalogin'].includes(this.$bus.getRole())) {
        if (this.$bus.session) {
          if (this.$bus.session.is_super_manage) {
            return this.$bus.roleFunctionsMap['merchant_admin']
          }
          else {
            return this.$bus.roleFunctionsMap['merchant_store']
          }
        }
        else {
          return this.$bus.roleFunctionsMap['merchant_store']
        }
      }
      //預設值
      return this.$bus.roleFunctionsMap['merchant_store']
    }
  },
  created () {
    // 把info alert box註冊到global bus裡,之後可到處用this.$bus.fnShowInfo('alert info msg')
    this.$bus.setHookCallback('fnGoLogin',this.goLogin)
    this.$bus.setHookCallback('fnShowInfo', this.showInfo)
    this.$bus.setHookCallback('fnShowConfirm', this.showConfirm)
    this.$bus.setHookCallback('fnClosePopup',this.acBoxClose)
    // 可惜Safari不支援BroadcastChannel,不然雙方都new一個出來監聽就很簡單
    /*this.bchannel = new BroadcastChannel('sw-messagesA');
    this.bchannel.addEventListener('message', event => {
      console.log('Page Received', event.data);
    });*/
    //iOS可能會死先mark掉
    /*this.msgc = new MessageChannel()
    let that = this
    this.msgc.port1.onmessage = function(event){
      if (event.data == 'connect back') {
        console.log('sw connect channel',event);
        console.log(event.ports[0])
        event.ports[0].postMessage('connect back msg')
        this.msgcc = event.ports[0]
      }
      else{
        //Response received from SW
        console.log('portA',event.data);
      }
      // 上面的嘗試想建立一個port之後好用那個port直接推信息給SW而不要navigator.serviceWorker.controller.postMessage失敗了= =
      //console.log('receive from SW:',event.data);
    };*/
  },
  mounted() {
    //iOS可能會死先mark掉
    /*if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage("establish channel", [this.msgc.port2]);
    }*/
    let line_token = this.getQueryVariable('accessToken')
    let line_uid = this.getQueryVariable('userId')
    let optional_hash = location.hash.indexOf('?')!==-1?location.hash.substr(0,location.hash.indexOf('?')):location.hash
    if (/*navigator.userAgent.indexOf('Line') > -1 &&*/ line_token && line_uid) {
      this.$bus.line_token = line_token
      this.$bus.line_uid = line_uid
    }
    const session_key =  this.$bus.getRole() + '_session'
    const session_raw = window.localStorage.getItem(session_key)
    this.$bus.session = undefined
    // getItem failed get a string of 'undefined', not undefined= =
    // 如果有line_user_id則一律重新做bindLineLogin(從line跳出去時自動用line裡面的帳號重登,避免打開的帳號與跳出時不同)
    if (session_raw && session_raw != 'undefined' && line_uid === false) {
      this.$bus.session = JSON.parse(session_raw)
    }
    else {
      if (this.$bus.getRole() !=='merchant_empty') {
        let optional_hash = location.hash.substr(0,location.hash.indexOf('?'))
        let landing = this.getQueryVariable('landing')
        let extra_uri_parameter_str = landing?(optional_hash+'?landing='+landing):''
        if (line_token && line_uid) {

          // line登入,要呼叫api做line登入,沒有綁定帳號時才跳登入(此時才保留url變數),登入若成功就清掉url參數並set login
          let Param = {
            module:'merchant',
            method:'bindLineLogin',
            line_id:line_uid,
            access_token:line_token
          }

          let vm = this
          apiBindLineLogin(Param).then(function(resp){
            let data = resp.data
            vm.setLoginData(data.data, landing)
          }).catch(function(error){
            let data = error.response.data
            if (data.ok === 0 || data.goLoginLineBind) {
              // vm.$bus.fnShowInfo(data.msg)
              setTimeout(() => {
                //一律在上面set,登入時一律再傳(api規則未解綁時不重複綁所以不影響)
                //這樣只要是在line裡面第一次進來有line_uid與line_token就會keep起來
                //這樣在核銷組件要另開時就可以組進去讓另開直接透過line登入了
                //vm.$bus.line_uid = line_uid
                //vm.$bus.line_token = line_token
                vm.$bus.session = null  
              }, 500);
              //失敗時要return不然會把data放到login結果導致行為異常
              return
            }
          })

          // this.$bus.apiCall(Param, function (data, vm) {
          //   if (data.ok === 0 || data.goLoginLineBind) {
          //     // vm.$bus.fnShowInfo(data.msg)
          //     setTimeout(() => {
          //       //一律在上面set,登入時一律再傳(api規則未解綁時不重複綁所以不影響)
          //       //這樣只要是在line裡面第一次進來有line_uid與line_token就會keep起來
          //       //這樣在核銷組件要另開時就可以組進去讓另開直接透過line登入了
          //       //vm.$bus.line_uid = line_uid
          //       //vm.$bus.line_token = line_token
          //       vm.$bus.session = null  
          //     }, 500);
          //     //失敗時要return不然會把data放到login結果導致行為異常
          //     return
          //   }
          //   vm.setLoginData(data.data, landing)
          //   //vm.resetUrlQuery(extra_uri_parameter_str)
          // }, this)
          return
        }
        else {
          setTimeout(() => {
            this.$bus.session = null
          }, 100);
          return
        }
      }
    }
    if (this.$bus.session && !this.checkMobile()) {
      setTimeout(() => {
        // 這個很機車,迴圈裡的動態組件的ref用字串取出,裡面又多一層,要到最後的li才能做click
        // 所以跨組件的子組件操作是絕對可行,能幫子組件的某元素手動點擊,只是ref的串連要多debug測試幾次
        if (this.$refs.sideBar.children[this.sideBarSelectIndex].landingComponent) {
          //this.$refs.sideBar.children[this.sideBarSelectIndex].click()
          this.$bus.landingComponent = this.roleFunctionItems[this.sideBarSelectIndex].actionComponent
        }
        else {
          let is_find = false
          let pathname = window.location.pathname.replace('/', '')
          console.log(pathname)
          for (let idx = 0; idx < this.roleFunctionItems.length; idx++){
            let item_pathname = this.roleFunctionItems[idx].pathname
            console.log(item_pathname)
            if (pathname === item_pathname) {
              this.$bus.landingComponent = this.roleFunctionItems[idx].actionComponent
              this.sideBarSelectIndex = idx
              is_find = true
              break
            }
          }

          if (is_find === false) {
            this.$bus.landingComponent = this.roleFunctionItems[0].actionComponent
          }
        }
      }, 300);
    }
    if (this.$bus.session && this.checkMobile()) {
        let urllanding = this.getQueryVariable('landing')
        if (urllanding && this.checkCanJump(urllanding)) {
            this.$bus.landingComponent = urllanding
        }
    }

    // this.resetUrlQuery(optional_hash)

    // 註冊關閉TopPopup的事件(傳入的callback執行時不方便存取這個根組件的關閉modal方法)
    this.$root.$off('top-popup-close')
    this.$root.$on('top-popup-close', function () {
      this.acBoxClose()
    }.bind(this))
  },
  watch:{
    '$bus.session'(newVal){
        //to work with changes in prop=>被登入失敗清空session時回登入
        if (newVal === null) {
          this.acBoxClose()
          setTimeout(() => {
            // 不能馬上就去按,組件是v-if動態載入,馬上去呼叫會undefined
            this.$refs.wrapper2.$refs.btnLogin.click()
          }, 300);
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottom-navigator {
  position:fixed;
  bottom:0;
  z-index: 999;
}
h2 {
  font-size: 10px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.center-block {
  display: block;
  margin: auto;
}
.m-nav {
  background-color: beige;
  background-blend-mode: soft-light;
}
.btm-nav {
  background-color:beige;
  width:100vw;
  background-blend-mode: soft-light;
  overflow-x: scroll;
  overflow-y: hidden;
  height:50px;
  border-style:outset;
  border-color: azure;
  padding: 2px;
}
.nav-wrapper {
  margin-bottom:50px;
}
a.nav-link:hover{
  color:mediumvioletred
}
.nav-item-icon-img {
  width: 16px;
  height:16px;
}
.selected-action {
  font-weight: bolder;
  background-color: lightblue;
}
.bInfo {
  background-color: ivory;
  border-left-color:goldenrod;
  border-left-width: 5px;
  padding-left:5px;
  border-left-style: solid;
}
.bConfirm {
  background-color: ivory;
  border-left-color:mediumblue;
  border-left-width: 5px;
  padding-left:5px;
  border-left-style: solid;
}
</style>
